import Box, { BoxProps } from '@mui/material/Box';
import clsx from 'clsx';
import Spinner from '../display/Spinner';
import classes from './LoadingBox.module.scss';

export default function LoadingBox({
  children = 'Loading…',
  className,
  displayed = true,
  ...rest
}: {
  displayed?: boolean;
} & BoxProps) {
  if (!displayed) {
    return null;
  }

  return (
    <Box className={clsx(classes.root, className)} {...rest}>
      <Spinner size="large" />
      <div className={classes.children}>{children}</div>
    </Box>
  );
}
